export default __webpack_public_path__ + "static/media/image.akshaya-technologies.70a5b5e7.png";